export default __webpack_public_path__ + "static/media/rocket.b12b0ce7.svg";